import Enum from '/@/modules/core/app/helpers/Enum';

export class EstateHealthCheckEventValue extends Enum {
  static NO_MAJOR_CHANGES: string = 'no_major_changes';
}
